// src/sections/hero/DesktopHero.jsx
import "./DesktopHero.css";
import { useLang } from "../../../../i18n/LangContext";

export default function DesktopHero({ onGetStarted, onContact, Right = null, id = "welcome" }) {
  const { t } = useLang(); // взимаме активния език

  return (
    <section id={id} className="hero-root hero-desktop" aria-label="Welcome section">
      <div className="hero-wrap">
        {/* Лява колона */}
        <div className="hero-left">
          <p className="hero-eyebrow">{t.home.eyebrow}</p>

          <h1 className="hero-title">
            {Array.isArray(t.home.title) ? (
              <>
                {t.home.title[0]}<br />{t.home.title[1]}
              </>
            ) : t.home.title}
          </h1>

          <p className="hero-desc">{t.home.desc}</p>

          <div className="home-overview-cta">
            <button className="home-overview-btn" onClick={onGetStarted}>
              <span className="home-overview-btn-inner">{t.home.cta.getStarted.toUpperCase()}</span>
            </button>

            <button className="home-overview-btn home-overview-btn-ghost" onClick={onContact}>
              <span className="home-overview-btn-inner">{t.home.cta.contact.toUpperCase()}</span>
            </button>
          </div>
        </div>

        {/* Дясната колона – твоя готов компонент/илюстрации */}
        <div className="hero-right">{Right ? <Right /> : null}</div>
      </div>
    </section>
  );
}
